/**
 * Cashback-specific form validators.
 *
 * Validates CASHBACK campaign-specific fields: terms & conditions,
 * extent guardrail, percent limit, and absolute limit.
 * Extracted from formValidationUtils for single-responsibility.
 *
 * @module cashbackValidation
 */

import { UseCampaignFormResult } from 'src/hooks/useCampaignForm/useCampaignForm';
import { parseOptionalNumber } from 'src/utils/helpers';
import { FieldErrors } from '../formValidationUtils';

// ============================================================================
// Public API
// ============================================================================

export function validateCashback(form: UseCampaignFormResult, f: FieldErrors): void {
    if (!form.termsAndConditions || form.termsAndConditions.trim().length === 0) {
        f.termsAndConditions = { key: 'cashback_terms_empty' };
    }

    const extent = parseOptionalNumber(form.cashbackExtentGuardrail);
    if (extent == null || extent < 1 || extent > 100) {
        f.cashbackExtentGuardrail = { key: 'cashback_extent_range' };
    }

    const percentLimit = parseOptionalNumber(form.cashbackPercentLimitGuardrail);
    if (percentLimit == null || percentLimit < 0 || percentLimit > 100) {
        f.cashbackPercentLimitGuardrail = { key: 'cashback_percent_limit_range' };
    }

    const absoluteLimit = parseOptionalNumber(form.cashbackAbsoluteLimitGuardrail);
    if (absoluteLimit == null || absoluteLimit < 1) {
        f.cashbackAbsoluteLimitGuardrail = { key: 'cashback_absolute_limit_range' };
    }
}
